import { Routes, Route, Navigate } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import ScrollToTopButton from "../components/footer/ScrollToTopButton";

import { AirHome, Health } from "../pages";

function AppRoutes() {
  return (
    <div className="w-full">
      <Navbar />
      <Routes>
        <Route path="/" element={<AirHome />} />
        <Route path="/health" element={<Health />} />
        <Route path="/*" element={<Navigate to="/" replace />} />
      </Routes>
      <ScrollToTopButton />
      <Footer />
    </div>
  );
}

export default AppRoutes;
